import React from "react";
import { NonTimerCard } from "./styles";
import { UserIcon } from "../../../../../../components/IconsSVG";

export const NonTimersProfessionalCard = ({ professional }) => {
  return (
    <NonTimerCard>
      {UserIcon("#fff")}
      <span>{`${professional.name} - Sem lançamentos`}</span>
    </NonTimerCard>
  );
};
